import styled from 'styled-components';

export const WrapperDiv = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    position: sticky;
    top: 6.8rem;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    margin: 0 0 ${props.theme.spacing.small.s5} 0;
    z-index: ${props.theme.misc.zIndex.xxlarge};
    background-color: ${props.theme.colors.white.bgWhite};
`,
);

export const InnerWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
`,
);

export const TextWrapper = styled.div(
  props => `
    flex-wrap: wrap;
    width: 100%;
    border-bottom: 0.1rem solid ${props.theme.colors.grey.lightd0};
    padding: ${props.theme.spacing.large.l15};
    
    .sub-text {
      font-size: ${props.theme.font.large.font18};
      font-weight: ${props.theme.font.fontWeight.black};
    }
    .main-text {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-weight: ${props.theme.font.fontWeight.black};
      font-size: ${props.theme.font.large.font30};
      text-transform: ${props.theme.font.textTransform.capital}
    }
  `,
);
